/* unplugin-vue-components disabled */import script from "./RemarksModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemarksModal.vue?vue&type=script&setup=true&lang=ts"

import "./RemarksModal.vue?vue&type=style&index=0&id=a0b88cb8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b88cb8"]])

export default __exports__